<script>
import { layoutComputed } from "@/state/helpers";
import { SimpleBar } from "simplebar-vue3";
import { getProductTemplateMenu } from "@/service"
// import md5 from "js-md5";
import { getLangValue } from "@/utils/common"; //获取后端语言
import _ from "lodash";
// import store from "@/state/store1";
import i18n from "@/i18n"
// 引入图标
import homeicon from '@/assets/images/menus/home.svg'; // 主页
import homeAicon from '@/assets/images/menus/home_active.svg';
// 服装
import databaseicon from '@/assets/images/menus/database.svg';
import databaseAicon from '@/assets/images/menus/database_active.svg';
// 产品数据库
import productDatabaseicon from '@/assets/images/menus/productDatabase.svg';
import productDatabaseAicon from '@/assets/images/menus/productDatabase_active.svg';
// hscode
import hscodeicon from '@/assets/images/menus/hscode.svg';
import hscodeAicon from '@/assets/images/menus/hscode_active.svg';
// 商业信息
import businessInfoicon from '@/assets/images/menus/businessInfo.svg';
import businessInfoAicon from '@/assets/images/menus/businessInfo_active.svg';
// 商业用户
import businessUsericon from '@/assets/images/menus/businessUser.svg';
import businessUserAicon from '@/assets/images/menus/businessUser_active.svg';
// 产品管理
import producticon from '@/assets/images/menus/product.svg';
import productAicon from '@/assets/images/menus/product_active.svg';
// 企业账户管理
import accounticon from '@/assets/images/menus/account.svg';
import accountAicon from '@/assets/images/menus/account_active.svg';
// 供应链
import supplyicon from '@/assets/images/menus/supply.svg';
import supplyAicon from '@/assets/images/menus/supply_active.svg';
// 系统管理
import settingicon from '@/assets/images/menus/setting.svg';
import settingAicon from '@/assets/images/menus/setting_active.svg';
// 产品线
import productLineicon from '@/assets/images/menus/productLine.svg';
import productLineAicon from '@/assets/images/menus/productLine_active.svg';
export default {
  components: { SimpleBar },
  data() {
    return {
      i18n,
      settings: {
        minScrollbarLength: 60,
      },
      menuList: [
        {
          router: "/homePage",
          key: "homePage",
          name: getLangValue('menu', 'home'),
          // icon: "ri-home-4-fill",
          icon: homeicon,
          iconA: homeAicon,
          permission: null,
          visible: true,
        },
        {
          router: "/hscode_management",
          key: "hscode_management",
          name: getLangValue("menu.hscode"),
          // icon: " ri-settings-6-fill",
          icon: hscodeicon,
          iconA: hscodeAicon,
          width: '18px',
          permission: 'hscode.list',
          visible: false,
        },
        {
          router: "/product_template",
          key: "product_template",
          name: getLangValue("menu.product-template"),
          // icon: "bx bxs-data",
          icon: productDatabaseicon,
          iconA: productDatabaseAicon,
          width: '18px',
          permission: 'product-template.list',
          visible: false,
        },
        {
          router: "/business_information_management",
          key: "business_information_management",
          name: getLangValue("menu.business-user"),
          // icon: "mdi mdi-account-check  ", //ri-team-fill bx bxs-user-account
          icon: businessUsericon,
          iconA: businessUserAicon,
          width: '18px',
          permission: 'business-user.list',
          visible: false,
        },
        {
          router: "/business_products_management",
          key: "business_products_management",
          name: getLangValue("menu.business-product"),
          // icon: "mdi mdi-basket-check ", //bx bxs-business
          icon: businessInfoicon,
          iconA: businessInfoAicon,
          width: '18px',
          permission: 'business-product.list',
          visible: false,
        },
        {
          router: "/product_line",
          key: "product_line",
          name: getLangValue("menu.my.product-line"),
          // icon: "ri-account-box-fill",
          icon: productLineicon,
          iconA: productLineAicon,
          active: false,
          width: '18px',
          permission: 'my.production-line.list',
          visible: false,
        },
        {
          router: "/productsList",
          key: "productsList",
          name: getLangValue("menu.product-management"),
          // icon: "ri-account-box-fill",
          icon: producticon,
          iconA: productAicon,
          width: '22px',
          permission: 'product-management.list',
          visible: false,
        },
        {
          router: "/public_database",
          key: "public_database",
          name: getLangValue("menu.public-database"),
          // icon: "ri-account-box-fill",
          icon: databaseicon,
          iconA: databaseAicon,
          width: '16px',
          permission: 'public-database',
          visible: true,
          children: [],
        },
        {
          router: "/account",
          key: "account",
          name: getLangValue("menu.my.account"),
          // icon: "ri-account-box-fill",
          icon: accounticon,
          iconA: accountAicon,
          width: '18px',
          permission: 'my.account.show',
          visible: false,
        },
        {
          router: "/supplyChain",
          key: "supplyChain",
          name: getLangValue("menu.my.supply-chain"),
          // icon: "ri-account-box-fill",
          icon: supplyicon,
          iconA: supplyAicon,
          width: '20px',
          permission: 'my.supply-chain.list',
          visible: false,
        },
        {
          router: "/",
          key: "system_management",
          name: this.$t("menu.system_management"),
          // icon: "ri-layout-grid-line",
          icon: settingicon,
          iconA: settingAicon,
          width: '18px',
          permission: "system-management",
          visible: false,
          children: [
            {
              router: "/role",
              name: this.$t("menu.role"),
              permission: "system-management.role",
              visible: false,
            },
            // {
            //   router: "/user",
            //   name: getLangValue("menu.user"),
            //   permission: "user",
            //   visible: false,
            // },
            {
              router: "/treeUser",
              name: this.$t("menu.user"),
              permission: "system-management.user",
              visible: false,
            },
            {
              router: "/permission",
              name: this.$t("menu.permission"),
              permission: "system-management.permission",
              visible: false,
            },
            {
              router: "/lang",
              name: this.$t("menu.lang"),
              permission: "system-management.language-configuration.list",
              visible: false,
            },
            {
              router: "/b2c",
              name: getLangValue("menu.b2c"),
              permission: "system-management.b2c.list",
              visible: false,
            },
          ],
        },
      ],
      updateTemplate: sessionStorage.getItem('updateTemplate')
    };
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {} || {};
      },
    },
    myUpdateTime: {
      get() {
        return this.$store ? this.$store.state.ft.updateTemplate : "" || "";
      },
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
    myUpdateTime: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this.updateTemplateFun();
        }
      }
    },
  },
  created() {
    this.getTemplate();
    this.setMenu();
  },
  mounted() {
    if (document.querySelectorAll(".navbar-nav .collapse")) {
      let collapses = document.querySelectorAll(".navbar-nav .collapse");
      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation();
          let closestCollapse = collapse.parentElement.closest(".collapse");
          if (closestCollapse) {
            let siblingCollapses =
              closestCollapse.querySelectorAll(".collapse");
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains("show")) {
                siblingCollapse.classList.remove("show");
              }
            });
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = [];
              let sibling = elem.parentNode.firstChild;
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
              }
              return siblings;
            };
            let siblings = getSiblings(collapse.parentElement);
            siblings.forEach((item) => {
              if (item.childNodes.length >= 0 && item.firstElementChild) {
                item.firstElementChild.setAttribute("aria-expanded", "false");
              }
              let ids = item.querySelectorAll("*[id]");
              ids.forEach((item1) => {
                item1.classList.remove("show");
                if (item1.childNodes.length >= 0) {
                  let val = item1.querySelectorAll("ul li a");

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute("aria-expanded"))
                      subitem.setAttribute("aria-expanded", "false");
                  });
                }
              });
            });
          }
        });

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation();
          let childCollapses = collapse.querySelectorAll(".collapse");
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse;
            childCollapseInstance.hide();
          });
        });
      });
    }
  },

  methods: {
    // getImg(nav) {
    //   // 获取nav的信息
    //   // this.$nextTick(() => {

    //     try {
    //       let a = document
    //         .querySelector("#navbar-nav")
    //         ?.querySelector(`[href="#menu${nav.key}"]`);
    //       // 判断 a是否包含 active
    //       if (a?.classList.contains('active')) {
    //         nav.active = true
    //       }
    //       nav.active = false
    //     } catch (e) {
    //       console.log(e);
    //     }

    //   // })
    // },
    async updateTemplateFun() {
      // 筛选信息
      let oldMenu = this.menuList.filter(item => !item.uukey)
      this.menuList = [...oldMenu];
      // 获取公开数据库菜单
      const resp = await getProductTemplateMenu();
      let obj = this.menuList.find(item => item.key === 'public_database')
      if (obj) {
        obj.visible = resp.payload.length ? true : false; // 如果公开数据长度大于0 才显示公开数据库
        obj.children = []; // 先置空
        resp.payload.forEach((element, i) => {
          // 设置一个唯一id
          element.id = element.name
          let m = {
            router: `/products/${element.id}?role_key=${element.role_key}`,
            key: element.id,
            name: element.name,
            name_en: element.name_en,
            icon: "ri-shirt-fill",
            permission: '',
            visible: true,
            uukey: 'products',
            role_key: element.role_key
          }
          obj.children.splice(i + 1, 0, m);
        })
      }
    },
    async getTemplate() {
      // 获取公开数据库菜单
      const resp = await getProductTemplateMenu();
      console.log(resp);
      // 先获取信息
      let obj = this.menuList.find(item => item.key === 'public_database')
      if (obj) {
        obj.visible = resp.payload?.length ? true : false; // 如果公开数据长度大于0 才显示公开数据库
        obj.children = []; // 先置空
        resp.payload?.forEach((element, i) => {
          // 设置一个唯一id
          element.id = element.name
          let m = {
            router: `/products/${element.id}?role_key=${element.role_key}`,
            key: element.id,
            name: element.name,
            name_en: element.name_en,
            icon: "ri-shirt-fill",
            permission: '',
            visible: true,
            uukey: 'products',
            role_key: element.role_key
          }
          obj.children.splice(i + 1, 0, m);
        })
      }
      // 缓存数据
      this.$store.commit('ft/setTMenuList', resp.payload)
    },
    setMenu() {
      let storeData =
        this.$store.state.login.menuList ||
        sessionStorage.getItem("set_menu_list");
      let permissions = null;
      if (storeData) {
        permissions = JSON.parse(storeData).permissions;
        permissions = _.join(permissions, ",");
      }
      this.menuList.forEach((menu) => {
        if (menu.children) {
          menu.children.forEach((child) => {
            if (permissions && _.includes(permissions, child.permission)) {
              // console.log(child);
              child.visible = true;
            }
          });
        } else {
          if (permissions && _.includes(permissions, menu.permission)) {
            menu.visible = true;
          }
        }
      });
      this.menuList.forEach((menu) => {
        if (menu.children) {
          menu.children.forEach((child) => {
            if (child.visible) {
              menu.visible = true;
            }
          });
        }
      });

      // console.log(permissions,this.menuList)
    },
    onRoutechange(ele) {
      // console.log(this.$route.query)
      this.$nextTick(() => {
        const data_type = this.$route.query.data_type;

        if (['textile_home_decor', 'textile_bedware', 'textile_industrial', 'textile_kitchen'].includes(data_type)) {
          this.initActiveMenu(`/${data_type}`)
        } else {
          const id = this.$route.params.id || this.$route.query.tid
          let key = this.$route.query.origin || ''; // 这个是产品管理进去的
          let key1 = this.$route.query.p_id || ''; // 这个是生产线进去的
          if (id && !key && !key1) {
            // 清空其他的
            if (document.querySelector("#navbar-nav")) {
              let aList = document
                .querySelector("#navbar-nav")
                .querySelectorAll('.active');
              // console.log(aList);
              if (aList.length > 0) {
                aList.forEach(element => {
                  element.classList.remove("active");
                });
              }
            }
            // 公开产品列表、详情都通过role_key来判断
            let role_key = this.$route.query.role_key;
            let href = `${ele.path}?role_key=${role_key}`;
            this.initActiveMenu(href, role_key)
          } else {
            // 父级只有一层的需要加menu
            // 父级多层的不需要加menu   多层的会在meta前面+/
            // 产品管理的列表、详情 
            if (key == 'productsList') {
              this.initActiveMenu('menuproductsList')
              return
            }
            // 产品线的列表、详情 
            if (key1) {
              this.initActiveMenu('menuproduct_line')
              return
            }
            // 系统管理有父级到这里
            ele.meta.father ? this.initActiveMenu(ele.meta.father.includes('/') ? `${ele.meta.father}` : `menu${ele.meta.father}`) : this.initActiveMenu(ele.path);
          }
        }
        if (document.getElementsByClassName("mm-active").length > 0) {
          const currentPosition =
            document.getElementsByClassName("mm-active")[0].offsetTop;
          if (currentPosition > 500)
            if (this.$refs.isSimplebar)
              this.$refs.isSimplebar.value.getScrollElement().scrollTop =
                currentPosition + 300;
        }
      })

      // console.log(1);
    },
    markmenu(a) {
      // 高亮菜单
      a.classList.add("active");
      let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
      if (parentCollapseDiv) {
        parentCollapseDiv.classList.add("show");
        parentCollapseDiv.parentElement.children[0].classList.add(
          "active"
        );
        parentCollapseDiv.parentElement.children[0].setAttribute(
          "aria-expanded",
          "true"
        );
        if (
          parentCollapseDiv.parentElement.closest(
            ".collapse.menu-dropdown"
          )
        ) {
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .classList.add("show");
          if (
            parentCollapseDiv.parentElement.closest(".collapse")
              .previousElementSibling
          )
            parentCollapseDiv.parentElement
              .closest(".collapse")
              .previousElementSibling.classList.add("active");
        }
      }
    },
    initActiveMenu(ele, role_key = '') {
      // console.log(ele);
      // 高亮
      let obj = this.menuList.find(item=> `menu`+item.key == ele || item.router == ele)
      if(obj) {
        obj.active = true;
        console.log(1);
      }
      this.$nextTick(() => {
        setTimeout(() => {
          // 普通的菜单 用这个
          if (document.querySelector("#navbar-nav")) {
            let a = document
              .querySelector("#navbar-nav")
              .querySelector(`[href="#${ele}"]`);
            // console.log(a);
            if (a) {
              this.markmenu(a)
            } else {
              // 公开产品的菜单 用这个
              if (role_key) {
                let a = document
                  .querySelector("#public_database")
                  .querySelector(`#id_${role_key}`);
                if (a) {
                  this.markmenu(a)
                } else {
                  this.initActiveMenu(ele, role_key)
                }
              }
            }
          }
        }, 1000);
      })

    },
    handlerJump(path, index) {
      this.menu_toggle = index;
      this.$router.push(path);
    },
  },
};
</script>

<template>
  <div class="container-fluid" style="height: 100%;">
    <template v-if="layoutType === 'twocolumn'">
      <SimpleBar class="navbar-nav" id="navbar-nav">
        <li class="nav-item">
          <a class="nav-link menu-link" href="#sidebarDashboards" data-bs-toggle="collapse" role="button"
            aria-expanded="false" aria-controls="sidebarDashboards">
            <i class="ri-layout-grid-line"></i>
            <span data-key="t-dashboards">YSR MES SYSTEM</span>
          </a>
          <div class="collapse menu-dropdown" id="sidebarDashboards">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-for="(nav, index) in menuList" :key="index">
                <router-link :to="nav.router" class="nav-link custom-abc" data-key="t-analytics">{{ nav.name
                }}</router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- end Dashboard Menu -->
      </SimpleBar>
    </template>

    <template v-else>
      <ul class="navbar-nav menu-scroll-bar" id="navbar-nav" style="height: calc(100% - 1rem); overflow-y: auto;">
        <li class="nav-item" v-for="(nav, index) in menuList" :key="index">
          <template v-if="nav.children">
            <a class="nav-link menu-link d-flex align-items-center" :href="`#${nav.key}`" data-bs-toggle="collapse"
              role="button" aria-expanded="false" aria-controls="sidebarDashboards" v-if="nav.visible">
              <!-- <i :class="nav.icon"></i> -->
              <div style="min-width: 28px; display: flex; align-items:start; justify-content: center;"><img :src="nav.icon"
                  :style="nav.width ? { width: nav.width, height: nav.width } : { width: '28px', height: '28px' }" />
              </div>
              <span :data-key="nav.key">{{ nav.name }}</span>
            </a>
            <div class="collapse menu-dropdown" :id="nav.key">
              <ul class="nav nav-sm flex-column" v-if="nav.children">
                <li class="nav-item" v-for="(child, i) in nav.children" :key="i">
                  <router-link v-if="child.visible" :to="child.router"
                    :id="child.role_key ? 'id_' + child.role_key : ''" class="nav-link custom-abc"
                    :data-key="nav.key">{{ i18n.global.locale == 'en' ? child.name_en ||
                      child.name :
                      child.name }}</router-link>
                </li>
              </ul>
            </div>
          </template>
          <!-- data-bs-toggle="collapse" -->
          <template v-else>
            <span v-if="nav.visible" :class="[
              'nav-link menu-link',
              ($route.path == nav.router ||
                $route.path == nav.router + '_detail/') &&
              'active',
            ]" :href="`#menu${nav.key}`" role="button" aria-expanded="false" aria-controls="sidebarDashboards"
              @click="handlerJump(nav.router, index)" class="d-flex align-items-center">
              <!-- <i :class="nav.icon"></i> -->
              <div style="min-width: 28px; display: flex; align-items:start; justify-content: center;">
                <img v-if="nav.active" :src="nav.iconA"
                  :style="nav.width ? { width: nav.width, height: nav.width } : { width: '28px', height: '28px' }" />
                <img v-else :src="nav.icon"
                  :style="nav.width ? { width: nav.width, height: nav.width } : { width: '28px', height: '28px' }" />
              </div>
              <span :data-key="nav.key">{{ i18n.global.locale == 'en' ? nav.name_en || nav.name : nav.name }}</span>
              <!-- <span>{{$route.path}}-{{nav.router}}</span> -->
            </span>
          </template>
        </li>
        <!-- end Dashboard Menu -->
      </ul>
    </template>
  </div>
  <!-- Sidebar -->
</template>

<style scoped>
.container-fluid {
  flex: 1;
}

.mdi {
  color: #aeb9e4;
}

.nav-link{
  height: 50px
}
.navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: #aeb9e4 !important;

  /* &::after {
    content: "\F0143";
  } */
}

.navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=false] {
  content: "\F0152";
}

.navbar-menu .navbar-nav .nav-sm .nav-link:before{
  top: unset !important
}
</style>
